import { ApiHttpClient } from "../../common/http/api-http-client";
import { HttpRequest } from "../../common/http/http-request";
import { ResourceBaseService } from "../../common/resource-base/resource-base.service";
import { WorkplaceDto } from "./workplace.dto";
import { CreateWorkplaceDto } from "./create-workplace.dto";
import { UpdateWorkplaceDto } from "./update-workplace.dto";
import { OptionType } from "@/types/OptionType";
import { IRequest } from "@/interfaces/IRequest";
import { applyOptionLoaderPagination } from "@/core/common/presenters/optionLoader";

export class WorkplacesResource extends ResourceBaseService<WorkplaceDto, CreateWorkplaceDto, UpdateWorkplaceDto> {
  protected EntityDto = WorkplaceDto;
  protected CreateEntityDto = CreateWorkplaceDto;
  protected UpdateEntityDto = UpdateWorkplaceDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/workplaces");
  }

  async optionLoader(inputValue: string): Promise<OptionType[]> {
    const request: IRequest = inputValue ? { search: inputValue, searchBy: ["id", "name"] } : {};
    request.sortBy = "name";
    const { data } = await this.findAll(applyOptionLoaderPagination(request));
    return data.map((value) => value.mapEntityToOptionType([value.name]));
  }

  async importWorkplaces(file: File): Promise<{ status: "queued"; jobId: string }> {
    const formData = new FormData();
    formData.append("file", file);

    return this.apiHttpClient.request<FormData, { status: "queued"; jobId: string }>(
      HttpRequest.create<FormData>({
        url: this.resourceUrl + "/import",
        method: "POST",
        auth: true,
        body: formData,
        type: "form-data",
      })
    );
  }
}
